import { useMemo } from "react";
import DataTable from "../components/table/ServerSideTable";
import { useMaterialsPaginated } from "../hooks/material.hooks";
import { ColumnDef } from "@tanstack/react-table";
import { Material, MaterialStatus } from "../types/material.types";
import { format } from "date-fns";
import { Button, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import MoreIcon from "../components/icons/MoreIcon";
import ProductBadge from "../components/ProductBadge";
import PenIcon from "../components/icons/PenIcon";
import { MoonIcon } from "@chakra-ui/icons";

export type MaterialTabProps = {
	onUpdate?: (material: Material) => void;
	onUpdateStatus?: (material: Material, status: MaterialStatus) => void;
};

const MaterialTab = ({ onUpdate, onUpdateStatus }: MaterialTabProps) => {
	const columns = useMemo<ColumnDef<Material>[]>(() => {
		return [
			{
				accessorFn: (row) => <>{row.id}</>,
				id: "id",
				header: "ID",
				cell: (info) => info.getValue(),
				sortDescFirst: true,
			},
			{
				accessorFn: (row) => <>{row.label}</>,
				id: "label",
				header: "Nom",
				cell: (info) => info.getValue(),
				sortDescFirst: true,
			},
			{
				accessorFn: (row) => (
					<>{row.updatedAt ? format(row.updatedAt, "dd/MM/yyyy") : "---"}</>
				),
				id: "updatedAt",
				header: "Dernière modification",
				cell: (info) => info.getValue(),
				sortDescFirst: true,
			},
			{
				accessorFn: (row) => <ProductBadge status={row.status}></ProductBadge>,
				id: "status",
				header: "Statut",
				cell: (info) => info.getValue(),
				sortDescFirst: true,
			},
			{
				accessorFn: (row) => <>{row.number}</>,
				id: "number",
				header: "Numéro",
				cell: (info) => info.getValue(),
				sortDescFirst: true,
			},
			{
				accessorFn: (row) => (
					<Menu>
						<MenuButton as={Button} variant="outlined" transition="all 0.2s">
							<MoreIcon w="24px" h="24px" />
						</MenuButton>
						<MenuList>
							<MenuItem
								lineHeight={"24px"}
								onClick={() => onUpdate && onUpdate(row)}
							>
								<PenIcon mr={4}></PenIcon>Modifier
							</MenuItem>
							<MenuItem
								lineHeight={"24px"}
								onClick={() =>
									onUpdateStatus &&
									onUpdateStatus(
										row,
										row.status === MaterialStatus.ACTIVE
											? MaterialStatus.INACTIVE
											: MaterialStatus.ACTIVE,
									)
								}
							>
								<MoonIcon mr={4}></MoonIcon>
								{row.status === MaterialStatus.ACTIVE
									? "Mettre en sommeil"
									: "Activer"}
							</MenuItem>
						</MenuList>
					</Menu>
				),
				id: "actions",
				header: "",
				cell: (info) => info.getValue(),
				sortDescFirst: true,
			},
		];
	}, []);
	return (
		<>
			<DataTable
				paginatedQuery={useMaterialsPaginated}
				columns={columns}
				w={["50px", "100px", "190px", "100px", "100px", "4px"]}
				flexGrow={[0, 3, 0, 0, 6, 1]}
			></DataTable>
		</>
	);
};

export default MaterialTab;
